import React, { ComponentType } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

type Props<C> = C extends ComponentType<infer P> ? Omit<P, 'client'> & { client: QueryClient } : never;

function withQueryClientAndRouter<C extends ComponentType<any>>(Component: C): React.FC<Props<C>> {
  return function WithQueryClient(props: Props<C>) {
    const { client, ...rest } = props;

    return (
      <BrowserRouter>
        <QueryClientProvider client={client}>
          <Component {...(rest as any)} />
        </QueryClientProvider>
      </BrowserRouter>
    );
  };
}

export default withQueryClientAndRouter;
